import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Riceverai immediatamente un’e-mail con il link per scaricare tutti i file PDF e i Bonus sul tuo dispositivo.'
}, {
  q: 'È adatto per docenti di sostegno o supplenti?',
  a: 'Assolutamente sì. È una risorsa preziosa per chiunque debba gestire le ore di Educazione Civica in modo strutturato e senza preavviso.'
}, {
  q: 'Posso usare il materiale anche se non ho una LIM in classe?',
  a: 'Certamente. Tutto il materiale è disponibile in formato PDF stampabile. Le presentazioni per la LIM sono un bonus aggiuntivo.'
}, {
  q: 'Il materiale è scaricabile per sempre?',
  a: 'Sì, una volta acquistato il kit è tuo per sempre. Potrai scaricare i file e riutilizzarli ogni anno scolastico.'
}, {
  q: 'Come funziona la garanzia di 7 giorni?',
  a: 'Hai 7 giorni di tempo dall’acquisto per esaminare tutto il kit. Se non sei soddisfatto, ti basta inviarci un’e-mail e riceverai il rimborso completo.'
}, {
  q: 'È adatto sia per le Medie che per le Superiori?',
  a: 'Sì, gli argomenti trattati (Costituzione, Digitale, Ambiente, ecc.) sono modulabili e le attività proposte si adattano a diversi livelli di approfondimento.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-dark py-24 px-4" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-16 tracking-tight" data-id="element-64">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-20" data-id="element-65">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-white border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-primary shadow-md' : 'border-border-light hover:border-primary/30'}`} data-id="element-66">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-67">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-68">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-primary' : 'text-text-sec'}`} data-id="element-69" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-70">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-71">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA Section */}
        <div className="text-center bg-white rounded-3xl p-10 sm:p-16 border border-border-light shadow-xl" data-id="element-72">
          <h3 className="text-2xl sm:text-4xl font-black text-text-main mb-4" data-id="element-73">
            Il prossimo anno scolastico può essere il più organizzato della tua
            carriera.
          </h3>
          <p className="text-text-sec text-lg mb-8" data-id="element-74">
            Oppure puoi continuare a preparare tutto da zero.
          </p>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block w-full sm:w-auto text-white shadow-[0_10px_30px_rgba(16,185,129,0.3)]" data-id="element-75">
            🚀 SÌ! VOGLIO IL KIT COMPLETO ORA
          </a>
        </div>
      </div>
    </section>;
}